module.exports = __webpack_public_path__ + "img/scan-round.30ca305e.png";